import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = (route) => {
  const permission = route.data?.['permission'] as string | undefined;
  const permissionAny = route.data?.['permissionAny'] as string[] | undefined;
  if (!permission) {
    if (!permissionAny?.length) {
      return true;
    }

    const permissionService = inject(PermissionService);
    const router = inject(Router);
    return permissionService.hasPermissions(permissionAny).pipe(
      map((results) =>
        permissionAny.some((code) => results[code]) ? true : router.parseUrl('/dashboard')
      )
    );
  }

  const permissionService = inject(PermissionService);
  const router = inject(Router);

  return permissionService.hasPermission(permission).pipe(
    map((allowed) => (allowed ? true : router.parseUrl('/dashboard')))
  );
};
